"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayStats = void 0;
const Stat = __importStar(require("root/src/client/web/giveaway/components/Stat"));
const useGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection");
const useGiveawayEntries_1 = require("root/src/client/web/giveaway/features/GiveawayStats/hooks/useGiveawayEntries");
const ActionEntry_1 = require("root/src/client/web/giveaway/features/GiveawayStats/ActionEntry");
const LoadingCircles_1 = __importDefault(require("root/src/client/web/base/LoadingCircles"));
const GiveawayStats = () => {
    return (<div className="flex flex-col gap-2">
			<GiveawayEntryStats />
			<GiveawayEntries />
		</div>);
};
exports.GiveawayStats = GiveawayStats;
const GiveawayEntryStats = () => {
    var _a, _b, _c;
    const { giveaway, stats, isLoading } = (0, useGiveawaySection_1.useGiveawaySection)();
    return (<div className="flex flex-initial gap-2">
			<Stat.Root className="flex w-2/3">
				<Stat.Label>Giveaway entries</Stat.Label>
				<Stat.Value>{isLoading ? <LoadingCircles_1.default width={30} height={30}/> : (_b = (_a = giveaway === null || giveaway === void 0 ? void 0 : giveaway.stats) === null || _a === void 0 ? void 0 : _a.entryCount) !== null && _b !== void 0 ? _b : 0}</Stat.Value>
			</Stat.Root>
			<Stat.Root className="flex w-1/3">
				<Stat.Label className="text-teal">Your entries</Stat.Label>
				<Stat.Value className="text-teal">{isLoading ? <LoadingCircles_1.default width={30} height={30}/> : (_c = stats.userEntries) !== null && _c !== void 0 ? _c : 0}</Stat.Value>
			</Stat.Root>
		</div>);
};
const GiveawayEntries = () => {
    const { isLogged, entriesList, isEntered } = (0, useGiveawayEntries_1.useGiveawayEntries)();
    if (!isLogged) {
        return null;
    }
    return (<ul role="list" className="flex flex-col gap-2">
			{entriesList.map(entry => (<li key={entry.label}>
					<ActionEntry_1.ActionEntry entry={entry} disabled={!isEntered}/>
				</li>))}
		</ul>);
};
